<template>
  <BaseSection heading="Gateway-Erkennung">
    <template #header>
      <button
        v-if="discoveryState.status !== 'scanning'"
        class="text-sm text-primary-2 hover:text-primary-1"
        @click="$emit('start-scan')"
      >
        Scan starten
      </button>
    </template>

    <div v-if="discoveryState.status === 'idle'">
      <PrimaryButton
        label="Gateway-Scan starten"
        @click="$emit('start-scan')"
      />
    </div>

    <div v-else-if="discoveryState.status === 'scanning'">
      <div class="flex items-center gap-2 text-sm mb-2">
        <em
          v-if="isConnected"
          class="mdi mdi-loading mdi-spin text-primary-2"
        />
        <em v-else class="mdi mdi-circle text-base text-gray-400" />
        <span>Suche nach Gateways…</span>
      </div>

      <GatewayTable
        v-if="discoveryState.gateways.length > 0"
        :gateways="discoveryState.gateways"
        :lte-rssi="discoveryState.lteRssi"
        :aes-keys="discoveryState.aesKeys"
        @select="$emit('select-gateway', $event)"
      />
    </div>

    <div v-else-if="discoveryState.status === 'error'">
      <BaseInformation
        :status="Status.ERROR"
        :information-text="discoveryState.message"
      />
      <PrimaryButton
        class="mt-4"
        label="Erneut versuchen"
        @click="$emit('start-scan')"
      />
    </div>
  </BaseSection>
</template>

<script setup lang="ts">
import type { GatewayDiscoveryState } from '@/composables/useQToolOperations';
import type { DiscoveredGateway } from '@/native/plugins/QTool';
import BaseSection from '@/components/UI/Card/BaseSection.vue';
import BaseInformation from '@/components/UI/Hint/BaseInformation.vue';
import PrimaryButton from '@/components/UI/Button/PrimaryButton.vue';
import GatewayTable from './DmgwGatewayDiscoveryTable.vue';
import { Status } from '@/enums/generic';

defineProps<{
  discoveryState: GatewayDiscoveryState;
  isConnected: boolean;
}>();

defineEmits<{
  'start-scan': [];
  'select-gateway': [gateway: DiscoveredGateway];
}>();
</script>
